<app-header></app-header>

<!-- 
if there is "failed" status
<div *ngIf="failedMessage$ | async as msg" class="failed-banner">
  {{ msg }}
</div> -->
<router-outlet></router-outlet>
<app-footer></app-footer>
